import { ItemInstance, TreeInstance } from '@headless-tree/core';
import React from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

import { LifeAreaRowData } from '../../types';
import { LifeAreaListCard } from '../life-area-list-card';

export type MenuPosition = { left: number; top: number };

export type TreeLifeAreaCardProps = {
  row: LifeAreaRowData;
  rowsById: Record<ID, LifeAreaRowData>;
  item: ItemInstance<InternalTreeItem>;
  tree: TreeInstance<InternalTreeItem>;
  isArchived?: boolean;
  isMultiSelectModifierPressed?: boolean;
  onOpenMultiSelectMenu: (
    position: MenuPosition,
    lifeAreas: LifeArea[],
  ) => void;
};

export const TreeLifeAreaCard: React.FC<TreeLifeAreaCardProps> = ({
  row,
  rowsById,
  item,
  tree,
  isArchived,
  isMultiSelectModifierPressed,
  onOpenMultiSelectMenu,
}) => {
  const isMultiSelected =
    item.isSelected() && tree.getSelectedItems().length > 1;

  // Only reached when the card suppressed its own menu — that one stops propagation.
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const position = { left: e.clientX, top: e.clientY };

    if (!item.isSelected()) {
      tree.setSelectedItems([item.getId()]);
      onOpenMultiSelectMenu(position, [row.lifeArea]);
      return;
    }

    const selected = tree
      .getSelectedItems()
      .map((selectedItem) => rowsById[selectedItem.getItemData().sourceId])
      .filter(Boolean)
      .map(({ lifeArea }) => lifeArea);

    onOpenMultiSelectMenu(
      position,
      selected.length ? selected : [row.lifeArea],
    );
  };

  return (
    <div onContextMenu={handleContextMenu}>
      <LifeAreaListCard
        row={row}
        isArchived={isArchived}
        isSelected={item.isSelected()}
        isDropTarget={item.isDragTarget()}
        preventInteraction={isMultiSelectModifierPressed}
        hideContextMenu={isMultiSelected || isMultiSelectModifierPressed}
      />
    </div>
  );
};
